import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
  refreshPage,
  toastStyle,
  getTodayDate,
  getType,
  selectDropdownStyle,
  getBranchId,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import {
  searchWastage,
  deleteWastage,
} from "../../../Helpers/apiCalls/Reports/DailyWastageApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import Footer from "../../../Components/Footer/Footer";

export default function SalesByItem() {
  let navigate = useNavigate();
  var dateToday = getTodayDate();
  const accountType = getType();

  const date = new Date();
  date.setDate(date.getDate() - 7);

  const [inactive, setInactive] = useState(true);
  const [filterConfig, setFilterConfig] = useState({
    branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
  });
  const [branches, setBranches] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [wastage, setWastage] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isClicked, setIsClicked] = useState(false);

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  const today = Moment().format("MM/DD/YYYY");

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  }

  function handleSelectChange(e, row) {
    setSelectedRow(row);

    if (e.target.value === "view") {
      window.open("/dailywastage/view/" + row.id, "_blank");
    } else if (e.target.value === "delete") {
      handleShowDeleteModal();
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
        {accountType === "admin" ? (
          <option value="view" className="color-options">
            View
          </option>
        ) : null}
        {accountType === "admin" ? (
          <option value="delete" className="color-options">
            Delete
          </option>
        ) : null}
      </Form.Select>
    );
  }

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={() => handleView(row)}
        // value="payment-pi"
      >
        View
      </button>
    );
  }
  function handleView(row) {
    window.open(
      "/dailywastage/view/" + row.id,
      "_blank"
    );
  }

  const handleTabSelect = (tabKey) => {
    setFilterConfig((prev) => {
      return {
        ...prev,
        tab: tabKey,
        branch_id: "",
        date_from: "",
        date_to: "",
      };
    });
  };

  async function fetchBranches() {
    setShowLoader(true);

    const response = await getAllBranches();
      setBranches([]);
    if (response.data) {
      var allBranches = response.data.data.data
        .filter((data) => {
          return data.is_franchise !== "3" && data.is_franchise !== "1";
        })
        .map((data) => {
          var branch = data;
          branch.label = data.name;
          branch.value = data.id;
          return branch;
        });
        if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
            var filteredBranch = allBranches.filter((data) => {
            return data.value === getBranchId()
            })
            setBranches(filteredBranch);
        } else {
            setBranches([{label: "All Branches", value:""}, ...allBranches]);
        }
    }
    setShowLoader(false);
  }

  async function fetchData() {
    setShowLoader(true);
    setWastage([]);

      const response = await searchWastage(filterConfig);

      if (response.error) {
        setWastage([]);
      } else {
        var allBills = response.data.data.map((bill) => {
          var items = "";
          var info = bill;
          info.wastage_date = Moment(bill.wastage_date).format("MMM DD, YYYY");
          bill.wastage_items.map((data) => {
            items = items + data.name + " ";
          });
          info.wastage_items_name = items;
          return info;
        });

        setWastage(allBills);
      }
      setShowLoader(false);
  }

  async function handleDeleteWastage() {
    setIsClicked(true);

      const response = await deleteWastage(selectedRow.id);
      if (response.data) {
        toast.success("Wastage Deleted Successfully!", {
          style: toastStyle(),
        });
        setTimeout(() => refreshPage(), 1000);
      } else {
        toast.error("Error Deleting Wastage", {
          style: toastStyle(),
        });
      }
    // else if(filterConfig.tab === "potato") {
    //     const response = await deleteWastagePotato(selectedRow.id);
    //     if (response.data) {
    //         toast.success("Wastage Deleted Successfully!", {
    //             style: toastStyle(),
    //         });
    //         setTimeout(() => refreshPage(), 1000);
    //     } else {
    //         toast.error("Error Deleting Wastage", {
    //             style: toastStyle(),
    //         });
    //     }
    // }
  }

  useEffect(() => {
    fetchBranches();
  }, []);

  useEffect(() => {
    fetchData();
  }, [filterConfig]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"DS REPORTS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> DAILY WASTAGE </h1>
          </Col>
          <Col xs={12} lg={5} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                  type="search"
                  name="branch_name"
              placeholder="Search branch name"
              className="search-bar"
              onChange={handleOnSearch}
              />
          </Col>
        </Row>

        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
            <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Branch"
                styles={selectDropdownStyle}
                options={branches}
                onChange={(e) => {
                setFilterConfig((prev) => {
                    return {
                        ...prev,
                        branch_id: e.value,
                    };
                })}}
            />
            </Col>
            <Col xs={6} lg={2}>
            <DatePicker
              autoComplete="off"
              selected={filterConfig.date_from}
              name="date_from"
              placeholderText={Moment(date).format("MM/DD/YYYY")}
              onChange={(date) => {
                setFilterConfig((prev) => {
                  return { ...prev, date_from: date };
                });
              }}
              fixedHeight
              className="date-filter me-4 form-control"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />
            </Col>
            <Col xs={6} lg={2}>
            <DatePicker
              autoComplete="off"
              selected={filterConfig.date_to}
              name="date_to"
              placeholderText={today}
              onChange={(date) => {
                setFilterConfig((prev) => {
                  return { ...prev, date_to: date };
                });
              }}
              fixedHeight
              className="date-filter ps-label-content me-5 form-control"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />
           </Col>
          </Row>
          <div className="mb-2" />

          <div className="my-2 px-2 PO-filters d-flex justify-content-center"></div>

          <div className="below">
            {/* table */}
            <Table
              tableHeaders={[
                "-",
                "DATE",
                "BRANCH",
                "WASTAGE ITEMS",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "wastage_date",
                "branch_name",
                "wastage_items_name",
              ]}
              tableData={wastage}
              ActionBtn={(row) => ActionBtn(row)}
              ViewBtn={(row) => ViewBtn(row)}
              showLoader={showLoader}
            />
          </div>
          <div className="mb-2" />
        </div>
      </div>

      {/* modals */}
      <Delete
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        text="wastage"
        onDelete={handleDeleteWastage}
        isClicked={isClicked}
      />
      <Footer/>
    </div>
  );
}
